
import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const createWarehouse = (brandId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/warehouse/api/v1/brand/' + brandId + '/ware-house', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const putWarehouse = (brandId, data) => {
  return axios({
    method: 'put',
    url: STORE_BASE_URL + '/warehouse/api/v1/brand/' + brandId + '/ware-house', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getBrandWarehouseById = warehouseId => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/warehouse/api/secure/v1/ware-house/' + warehouseId, // for android use
    headers: getHeaders(),
  });
};

export const getBrandWarehouse = brandId => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL + '/warehouse/api/v1/brand/' + brandId + '/ware-house', // for android use
    headers: getHeaders(),
  });
};

export const getWarehouseDashboardQrCode = (warehouseId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL + '/warehouse/api/secure/v1/ware-house/' + warehouseId + '/qr-code', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

// https://dhobicart.in/warehouse/api/secure/v1/ware-house/1/qr-code